
export interface IssueReportForm {
  attachments?: File[];
  description: string;
  email: string;
  issueType: string;
  location: string;
  phone: string;
  priority: string;
  subject: string;
  tripId: string;
}

import api from "./api";

export async function submitIssueReport(formData: IssueReportForm) {
  const data = new FormData();

  // Map frontend fields to backend fields
  data.append("issue_type", formData.issueType);
  data.append("priority", formData.priority);
  data.append("email", formData.email);
  data.append("phone_number", formData.phone);
  data.append("trip_id", formData.tripId);
  data.append("location", formData.location);
  data.append("subject", formData.subject);
  data.append("description", formData.description);

  // Attach files if any
  if (formData.attachments && formData.attachments.length > 0) {
    (Array.from(formData.attachments) as File[]).forEach((file: File) => {
      data.append("attachments[]", file);
    });
  }

  try {
    const response = await api.post("/report/issue", data);
    return response.data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.errors) {
      throw new Error(
        Object.values(error.response.data.errors).flat().join(", "),
      );
    }
    throw new Error(
      error.response?.data?.message || "Failed to submit report.",
    );
  }
}

